import { postIamAuthorise, postIamLogin } from '@modv/sdk'

export default {
  namespaced: true,
  state: {
    session: {}
  },
  getters: {
    jwt: (state) => {
      return state.session.jwt
    },
    userId: (state) => {
      return state.session.userId
    }
  },
  mutations: {
    SET_SESSION: (state, { res }) => {
      state.session = res.data
      localStorage.setItem('profile', JSON.stringify(res.data))
    }
  },
  actions: {
    async authorize({ commit }) {
      const res = await postIamAuthorise()
      commit('SET_SESSION', {
        res
      })
    },
    async loginDirect({ commit }, params) {
      const res = await postIamLogin({
        email: params.email,
        password: params.password
      })
      commit('SET_SESSION', {
        res
      })

      return res.data
    }
  }
}
